export const tokens = {
    suffix: {
        marginLeft: {
            default: 12,
            compact: 8,
        },
    },
    label: {
        fontSize: {
            default: 14,
            compact: 12,
        },
    },
    conversion: {
        fontSize: {
            default: 12,
            compact: 10,
        },
    },
};
